module.exports = __webpack_public_path__ + "static/media/gradient03.50e8ebdf.jpg";